import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { FeatureHomein } from '../../../Core/Features/FeactureHomeIn/FeatureHomeIn';
import { closeSession, isActive, getUser } from '../../../Core/Features/FeatureGlobal';
import ButtonNavLinkMobile from '../../Atoms/Buttons/ButtonNavLinkMobile/ButtonNavLinkMobile';
import ButtonHelp from '../../Atoms/Buttons/Help/ButtonHelp';
import ButtonHeader from '../../Atoms/Buttons/Help/ButtonHeaderHomeIn';
import ButtonPrimary from '../../Atoms/Buttons/Primary/ButtonPrimary';
import ButtonSecondary from '../../Atoms/Buttons/Secondary/ButtonSecondary';
import LogoNav from '../../Atoms/LogoNav/LogoNav';
import "./NavBar.css";
import ButtonSecondaryBordered from '../../Atoms/Buttons/Secondary/ButtonSecondaryBordered';
import ModalPincipalMenu from '../Modals/ModalMenuMobile/ModalPincipalMenu';

function NavBar() {
  
  const [type,setType]=useState(0)
  const [show, setShow] = useState(false)
  useEffect(() => {
      if (isActive()) {
          setTimeout(()=>{
        switch (getUser()?.servicio){
            case 'desempleo' : 
                setType(1)
                break;
            case 'itt' : 
                setType(2)
                break;
        }
          },1000)
      }
  }, [])

  const handleOutsideClick = () => {
    setShow(false);
    // Aquí puedes ejecutar la función que deseas cuando se hace clic fuera del elemento
  };


  return (
    <>
      {show && (<ModalPincipalMenu onOutsideClick={handleOutsideClick} setShow={setShow} type={type} />)}
      {isActive() ? (
        <>
          <Navbar className='nav__general ' expand="lg" id="navBarTop">
            <Container >
              <Navbar.Brand href="/" className='supp_nav_brand'>
                <LogoNav type_logo={1}/>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls="basic-navbar-nav" onClick={()=>{setShow(!show)}} >
              </Navbar.Toggle>
              <Navbar.Collapse className="backgraund d-none d-lg-block" id="basic-navbar-nav">
                <Nav className="ms-auto">
                  <div className='d-block d-md-none'>
                    <Nav.Link className='navlink__mobile' href="/homein">
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkHome'}
                        text__navlink__mobile={type == 1 ? 'Asalariado' : 'Independiente'}
                      />
                    </Nav.Link>
             
                    <Nav.Link className='navlink__mobile' href="/mi-perfil">
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkProfile'}
                        text__navlink__mobile={'Mi perfil'}
                      />
                    </Nav.Link>
                    <Nav.Link className='navlink__mobile' href="/centro-de-ayuda">
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkHelp'}
                        text__navlink__mobile={'Ayuda'}
                      />
                    </Nav.Link>
                  
                    <Nav.Link className='navlink__mobile' onClick={() => { closeSession() }}>
                      <ButtonNavLinkMobile
                        classname__link__mobile={'ButtonNavLinkMobile iconNavlinkLogout'}
                        text__navlink__mobile={'Cerrar sesión'}
                      />
                    </Nav.Link>
                  </div>
                  <div className='d-none d-lg-block'>
                    <Row>
                    <Col className='col-auto'>
                        <Nav.Link href="/">
                          <ButtonHeader children={'Inicio'} />
                        </Nav.Link>                      
                      </Col>
                      <Col className='col-auto'>
                        <Nav.Link href="/centro-de-ayuda">
                          <ButtonHeader children={'Ayuda'} />
                        </Nav.Link>                      
                      </Col>
                   
                      <Col className='col-auto'>
                        <Nav.Link href="/mi-perfil">
                          <ButtonHeader children={'Perfil'} />
                        </Nav.Link>                      
                      </Col>
                      <Col className='col-auto'>
                        <Nav.Link onClick={() => { closeSession() }}>
                          <ButtonHeader onClick={() => { closeSession() }} children={'Cerrar sesión'} />
                        </Nav.Link>                      
                      </Col>
             
                    </Row>
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      ): (
        <>
          <Navbar className='nav__general' bg="light" expand="lg">
            <Container fluid className='p-0'>
              <Navbar.Brand className='px-2' href="/"><LogoNav type_logo={2}/></Navbar.Brand>
              <Navbar.Collapse id="basic-navbar-nav">
                <Nav className="ms-auto">
                  <div className='d-none d-lg-block'>
                    <Row className='w-100 m-0 px-2'>
                      <Col className='col-auto p-0'>
                        <Nav.Link href="/centro-de-ayuda">
                          <ButtonSecondary 
                          className={'supp_styles_btn_help_header'}
                          children={'Ayuda'}
                        />
                        </Nav.Link>
                      </Col>
                      <Col className='col-auto p-0'>
                        <Nav.Link href="/inicia-sesion" className='nav__link'>
                          <ButtonPrimary children={'Iniciar sesión'} />
                        </Nav.Link>
                      </Col>
                      <Col className='col-auto p-0'>
                        <Nav.Link href="/registro">
                          <ButtonSecondaryBordered
                            className={'supp_styles_btn_register_header'}
                            children={'Regístrate'} 
                          />
                        </Nav.Link>
                      </Col>
                    </Row>
                  </div>
                </Nav>
              </Navbar.Collapse>
            </Container>
          </Navbar>
        </>
      )}
    </>
  );
}

export default NavBar;


